export enum CertificateType {
	COMMERCIAL = 'commercial',
	SUKL = 'sukl',
}
